import { combineReducers } from '@reduxjs/toolkit';
import loaderReducer from './loader.slice';
import authReducer from './auth.slice';
import findReducer from './find.slice';
import sidemenuReducer from './sidemenu.slice';
import commonCodeReducer from './commonCode.slice';
import campusDataReducer from './campusData.slice';
import serverDateReducer from './serverDate.slice';
import holidayReducer from './holiday.slice';
import convertReducer from './convert.slice';
import criteriaReducer from './criteria.slice';
import courseReducer from './course.slice';
import evaluationReducer from './evaluation.slice';
import semesterReducer from './semester.slice';
import semesterActivityReducer from './semesterActivity.slice';
import staffReducer from './staff.slice';
import resumeReducer from './resume.slice';
import contractReducer from './contract.slice';
import staffCounselReducer from './staffCounsel.slice';
import housingReducer from './housing.slice';
import classroomReducer from './classroom.slice';
import classReducer from './class.slice';
import classStudentReducer from './classStudent.slice';
import classTimetableReducer from './classTimetable.slice';
import studentReducer from './student.slice';
import studentClassReducer from './studentClass.slice';
import studentCounselReducer from './studentCounsel.slice';
import studentPaymentReducer from './studentPayment.slice';
import studentCouponReducer from './studentCoupon.slice';
import imageReducer from './image.slice';
import alarmReducer from './alarm.slice';
import couponReducer from './coupon.slice';
import couponCampusReducer from './couponCampus.slice';
import campusReducer from './campus.slice';
import codeReducer from './code.slice';
import schoolReducer from './school.slice';
import menuReducer from './menu.slice';
import groupReducer from './group.slice';
import localeReducer from './locale.slice';
import permitReducer from './permit.slice';
import notificationReducer from './notification.slice';
import studentStudentReducer from './student.student.slice';
import pushMessageReducer from './pushMessage.slice';
import memberReducer from './member.slice';
import { apiSlice } from '../api/apiSlice';
import entranceCounselorReducer from './entranceCounselor.slice';
import verifyReducer from './verify.slice';
import treeCodeReducer from './treeCode.slice';
import treeCodeDataReducer from './treeCodeData.slice';

const rootReducer = combineReducers({
  loader: loaderReducer,
  auth: authReducer,
  find: findReducer,
  sidemenu: sidemenuReducer,
  commonCode: commonCodeReducer,
  campusData: campusDataReducer,
  serverDate: serverDateReducer,
  holiday: holidayReducer,
  convert: convertReducer,
  criteria: criteriaReducer,
  course: courseReducer,
  evaluation: evaluationReducer,
  semester: semesterReducer,
  semesterActivity: semesterActivityReducer,
  staff: staffReducer,
  resume: resumeReducer,
  contract: contractReducer,
  staffCounsel: staffCounselReducer,
  housing: housingReducer,
  classroom: classroomReducer,
  class: classReducer,
  classStudent: classStudentReducer,
  classTimetable: classTimetableReducer,
  student: studentReducer,
  studentClass: studentClassReducer,
  studentCoupon: studentCouponReducer,
  studentCounsel: studentCounselReducer,
  studentPayment: studentPaymentReducer,
  image: imageReducer,
  alarm: alarmReducer,
  coupon: couponReducer,
  couponCampus: couponCampusReducer,
  campus: campusReducer,
  code: codeReducer,
  school: schoolReducer,
  menu: menuReducer,
  group: groupReducer,
  permit: permitReducer,
  locale: localeReducer,
  notification: notificationReducer,
  studentStudent: studentStudentReducer,
  pushMessage: pushMessageReducer,
  member: memberReducer,
  entranceCounselor: entranceCounselorReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  verify: verifyReducer,
  treeCode: treeCodeReducer,
  treeCodeData: treeCodeDataReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
